export const certificates = {
  title: 'Certificates',
  resourceName: 'Certificates',
  titles: {
    list: 'Certificate list',
    detail: 'Certificate details',
    create: 'Create certificate',
    edit: 'Edit certificate',
    addQuick: 'Add quick',
  },
  sections: {
    basic: 'Basic information',
    linkage: 'Linked companies',
    validity: 'Validity and status',
    note: 'Notes',
    audit: 'Notes and system metadata',
  },
  units: {
    days: 'days',
  },
  fields: {
    code: 'Certificate code',
    name: 'Certificate name',
    certificateType: 'Certificate type',
    licenseNumber: 'License number',
    expiryDate: 'Expiry date',
    warningDays: 'Warning days',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    status: 'Status',
    onOffAction: 'On / Off',
    certificateName: 'Certificate name',
    productCode: 'Linked product',
    registeredCompany: 'Registered company',
    exporterCompany: 'Exporter company',
    importerCompany: 'Importer company',
    effectiveDate: 'Effective date',
    issueDate: 'Issue date',
    daysToExpire: 'Time to expiry',
    warningBeforeExpiry: 'Warn 60 days before expiry',
    note: 'Note',
    actions: 'Actions',
  },
  filter: {
    country: 'Company country',
    allCountries: 'All',
  },
  countries: {
    VN: 'Vietnam',
    TQ: 'China',
  },
  status: {
    active: 'Active',
    inactive: 'Inactive',
    enabled: 'Enabled',
    disabled: 'Disabled',
  },
  validation: {
    nameRequired: 'Please enter certificate name',
    companyRequired: 'Please select all 3 companies',
  },
  messages: {
    importDescription: 'Choose the correct Excel template to import certificates.',
    importSuccess: 'Certificates imported successfully',
    importFailed: 'Certificate import failed',
    exportSuccess: 'Export completed successfully',
    exportFailed: 'Export failed',
    noData: 'No certificate data',
    totalCertificates: 'Total: {total} certificates',
    createSuccess: 'Certificate created successfully',
    updateSuccess: 'Certificate updated successfully',
    deleteSuccess: 'Certificate deleted successfully',
    confirmDelete: 'Are you sure you want to delete this certificate?',
  },
  import: {
    button: 'Import',
    noSheet: 'No worksheet found in import file',
    noData: 'No data to import',
    success: 'Imported {count} rows successfully',
    failed: 'Import failed',
  },
}
